"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SalesOrderReleaseSearchResponse = void 0;
const common_1 = require("../../common");
const models_1 = require("../models");
class SalesOrderReleaseSearchResponse extends common_1.PaginatedResponse {
}
exports.SalesOrderReleaseSearchResponse = SalesOrderReleaseSearchResponse;
//# sourceMappingURL=sales-order-release-search.response.js.map